export default __webpack_public_path__ + "6fc26950717f8b8e5fc3c5bc8eb9244f.png";